import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  type ShowsSeriesWithShows,
  getSeriesForVenuePage,
  SERIES_QUERY_KEY,
} from "./api";

/**
 * Hook to fetch all series for a venue page
 */
export function useVenuePageSeries(
  venuePageId: string | undefined
): UseQueryResult<ShowsSeriesWithShows[], Error> {
  return useQuery({
    queryKey: [SERIES_QUERY_KEY, venuePageId],
    queryFn: () => getSeriesForVenuePage(venuePageId!),
    enabled: !!venuePageId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
